import React from 'react'
import { connect } from 'react-redux'
import withSizes from 'react-sizes'
import { string, func, bool } from 'prop-types'
import { toggleStreetView } from '../../../store/Actions/UiActions'
import StreetViewIcon from '../../../assets/img/Street_View_logo.png'
import Img from 'react-image'
import { Div } from './styles'

const StreetViewMap = ({
  image,
  address,
  toggleStreetView,
  online,
  theme,
  signs,
  isMobile,
}) =>
  image &&
  isMobile && (
    <Div
      onClick={() => online && toggleStreetView(true)}
      theme={theme}
      signs={signs}
    >
      <Img
        src={StreetViewIcon}
        alt={`Street view of ${address}`}
        title={`Street view of ${address}`}
      />
    </Div>
  )

StreetViewMap.propTypes = {
  image: string.isRequired,
  address: string.isRequired,
  toggleStreetView: func.isRequired,
  online: bool.isRequired,
  theme: string.isRequired,
  signs: bool.isRequired,
  isMobile: bool.isRequired,
}

const mapStateToProps = ({ signsState, spi }) => ({
  image: signsState.cache.streetViewImage,
  address: signsState.addressCache,
  online: spi.online,
  theme: spi.theme,
  signs: signsState.signs.length > 0,
})

const mapDispatchToProps = dispatch => ({
  toggleStreetView: value => dispatch(toggleStreetView(value)),
})

const mapSizesToProps = ({ width }) => ({ isMobile: width <= 750 })

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withSizes(mapSizesToProps)(StreetViewMap))



// WEBPACK FOOTER //
// ./src/components/Elements/StreetViewMap/index.jsx